import React from 'react';
import './TutorialVideoSearch.css';

export function TutorialVideoSearch({ searchTerm, onSearchChange, placeholder = "Search videos..." }) {
  const handleSearchChange = (e) => {
    onSearchChange(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    // Could add search submission logic here if needed
  };

  return (
    <form className="tutorial-video-search-form" onSubmit={handleSearchSubmit}>
      <div className="tutorial-video-search-container">
        <i className="fa-solid fa-magnifying-glass tutorial-video-search-icon"></i>
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder={placeholder}
          className="tutorial-video-search-input"
        />
      </div>
    </form>
  );
}